"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_LOCALES = exports.FALLBACK_LOCALE = exports.EXTERNAL_LOCALES = exports.ALL_LOCALES = exports.DEFAULT_LOCALE = exports.LOCALES = void 0;
exports.LOCALES = {
    AR: 'ar',
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    JA: 'ja',
    PT: 'pt_BR'
};
exports.DEFAULT_LOCALE = exports.LOCALES.PT;
exports.ALL_LOCALES = Object.keys(exports.LOCALES).map((key) => exports.LOCALES[key].toUpperCase());
exports.EXTERNAL_LOCALES = exports.ALL_LOCALES.filter((locale) => locale !== exports.DEFAULT_LOCALE);
exports.FALLBACK_LOCALE = exports.LOCALES.EN;
exports.SUPPORTED_LOCALES = [
    exports.LOCALES.EN,
    exports.LOCALES.ES,
    exports.LOCALES.FR,
    exports.LOCALES.PT
];
